module.exports = __webpack_public_path__ + "img/zp-img2.c265525e.png";